module.exports = __webpack_public_path__ + "img/company6.77a18c07.png";